import React, { useEffect, useRef, useState, useReducer } from "react";
import "./crps.css";
import { alert } from "devextreme/ui/dialog";
import ScrollView from "devextreme-react/scroll-view";
import FileUploader from "devextreme-react/file-uploader";
import Button from "devextreme-react/button";
import * as action from "../../actions/rps";
import NEXUS_CONST from "../../common/constants";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import "../../styles/scss/gallery.scss";
import { confirm } from "devextreme/ui/dialog";
import ACTION_TYPES from "../../actions/actionTypes";

import moment from "moment";
import { getTypeOfFile, onDownloadFile } from "../../common/utils";

import DataGrid, {
  Column,
  Editing,
  Paging,
  Scrolling,
} from "devextreme-react/data-grid";
import TextBox from "devextreme-react/text-box";
import DateBox from "devextreme-react/date-box";
import rpsReducer from "../../reducers/rps";
import LineChart from "./LineChart";
import {
  ALLOWED_FILE_EXTENSIONS,
  ALLOWED_MIME_TYPES,
} from "../../constants/allowedUploadTypes";
import { checkUploadFilesValid } from "../../utils/fileValidator";

const initialStates = {
  ophFile: null,
  confirmresultsGridData: null,
};
const ConfirmedResultsRPS = ({
  rpsID,
  handleSPSSave,
  tierId,
  siteId,
  activeAlert,
  chartId,
  setisOpen,
  navigationOn,
}) => {
  const [selectedTimePeriod, setSelectedTimePeriod] = useState(30);
  const [selectedFrequency, setSelectedFrequency] = useState("Daily");
  const [selectedDate, setSelectedDate] = useState("");
  const [checker, setChecker] = useState(false);
  const dataGridRef = useRef(null);
  const [gridData, setGridData] = useState([]);
  const [theRpsId, setTheRpsId] = useState(rpsID == null ? -1 : rpsID);
  const [state, dispatch] = useReducer(rpsReducer, initialStates);
  const [kpiInfo, setKpiInfo] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [image, setImage] = useState(null);
  const [targetTitle, setTargetTitle] = useState("Target");
  const [actualTitle, setActualTitle] = useState("Actual");
  const [rpsAllData, setrpsAllData] = useState(undefined);
  const [enableSave, setEanbleSave] = useState(false);
  let { rcaConfirmResultData, resultsAttachmentData } = state;

  useEffect(() => {
    // GridDataFetch
    action.fetchConfirmResultGridData(dispatch, theRpsId);
    action.resultsGetAttachmentsData(dispatch, theRpsId, "Result");
  }, []);

  useEffect(() => {
    if (enableDisableCntrols()) {
      setGridData(rcaConfirmResultData);

      AsyncCallHandler(
        NEXUS_CONST.FETCH_PS_DATA + theRpsId,
        NEXUS_CONST.GET
      ).then((res) => {
        if (res) {
          setrpsAllData(res.data);
          setSelectedFrequency(res?.data?.resultFrequency);
          setSelectedTimePeriod(res?.data?.resultTimePeriod);
          setSelectedDate(res?.data?.resultsStartDate);
          setEanbleSave(res?.data?.status === "Complete");
          let KPIString = res.data.kpiunits;

          setTargetTitle(KPIString + " Target");
          setActualTitle(KPIString + " Actual");
        }
      });
    }
  }, [rcaConfirmResultData]);

  const handleDateChange = (event) => {
    if (!enableDisableCntrols()) {
      let date = event.value;
      let isNoClicked = false;

      if (gridData.length > 0) {
        isNoClicked = true;
        if (event.previousValue === selectedDate) {
          confirm(
            "Changing the Date will reset the data. Are you sure you want to proceed?"
          ).then((res) => {
            if (res) {
              setSelectedDate(date);
              gridDataPopulation("", "", date);
              return;
            } else {
              let prev = selectedDate;
              event.component.option("value", prev);
              return false;
            }
          });
        }
      } else {
        if (date !== null && date !== "" && !isNoClicked) {
          setSelectedDate(date);
          let length =
            selectedFrequency === "Daily"
              ? selectedTimePeriod
              : Math.floor(selectedTimePeriod / 7);
          let grdData = [];

          for (let i = 0; i < length; i++) {
            let temp = {
              resultsID: 0,
              resultDate: moment(date)
                .add(selectedFrequency === "Daily" ? i : i * 7, "days")
                .format("MM-DD-YYYY"),

              target: "",
              actual: "",
              notes: "",
              rpsid: theRpsId,
            };

            grdData.push(temp);
          }

          setGridData(grdData);
        }
      }
    }
  };

  const gridDataPopulation = (freq, timePeriod, date) => {
    if (selectedDate !== null && selectedDate !== "") {
      let tempTimeperiod = timePeriod === "" ? selectedTimePeriod : timePeriod;
      let tempFrequency = freq === "" ? selectedFrequency : freq;
      let tempDate = date === "" ? selectedDate : date;

      let length =
        tempFrequency === "Daily"
          ? tempTimeperiod
          : Math.floor(tempTimeperiod / 7);
      let grdData = [];

      for (let i = 0; i < length; i++) {
        let temp = {
          resultsID: 0,
          resultDate: moment(tempDate)
            .add(tempFrequency === "Daily" ? i : i * 7, "days")
            .format("MM-DD-YYYY"),

          target: "",
          actual: "",
          notes: "",
          rpsid: theRpsId,
        };

        grdData.push(temp);
      }

      setGridData(grdData);
    }
  };

  const onInitNewRow = (e) => {
    e.data.DefectReason = "";
    e.data.Category = "";
    e.data.actual = 0;
  };

  const onSaving = () => {
    setEanbleSave(true);
    dataGridRef.current?.instance?.saveEditData();

    let data = {
      rpsid: theRpsId,
      resultTimePeriod: selectedTimePeriod,
      resultFrequency: selectedFrequency,
      kpiUnits: kpiInfo,
      resultModel: gridData,
      lastSavedTab: "8",
      section:navigationOn,
      siteId:siteId,
      tierId:tierId,
    };
    let totalFileSize = selectedFiles?.reduce((acc, cur) => {
      return (acc = acc + cur.size);
    }, 0);

    // if (
    //   !enableDisableCntrols() &&
    //   (kpiInfo == "" ||
    //     selectedTimePeriod == "" ||
    //     selectedFrequency == "" ||
    //     selectedDate == "" ||
    //     gridData.some((temp) => temp.target === "" || temp.target === null)))

    if (
      kpiInfo == "" ||
      selectedTimePeriod == "" ||
      selectedFrequency == "" ||
      selectedDate == "" ||
      gridData.some((temp) => temp.target === "" || temp.target === null) ||
      (selectedFiles?.length > 0 && totalFileSize > 4000000)
    ) {
      setEanbleSave(false);
      alert(
        "Please fill all the fields (KPI,Time Period,Reporting Frequency and Target in the table) and<br/> Make sure sum of uploaded files size is less than 4MB"
      );
      return false;
    }

    AsyncCallHandler(
      NEXUS_CONST.ADD_CONFIRM_RESULT,
      NEXUS_CONST.POST,
      data
    ).then((res) => {
      if (res) {
        if (selectedFiles?.length === 0) {
          setEanbleSave(false);
        }
        action.fetchConfirmResultGridData(dispatch, theRpsId);

        handleSPSSave();
      }
    });

    if (selectedFiles?.length > 0) {
       // Check files are valid or not
       const validateUploadFiles = checkUploadFilesValid(
        selectedFiles,
        ALLOWED_MIME_TYPES
      );

      if (validateUploadFiles.length) {
        const alertMsg = validateUploadFiles.map(
          (file) => `${file.name} - ${file.reason}`
        );
        alert(alertMsg.join("<br/>"), "Alert");
        setEanbleSave(false);
        return false;
      }

      let formData = new FormData();
      if (
        selectedFiles &&
        selectedFiles.length &&
        Array.isArray(selectedFiles)
      ) {
        selectedFiles.forEach((file) => {
          formData.append("files", file);
        });
      }
      formData.append("rpsId", theRpsId ? theRpsId : -1);
      formData.append("attachmentType", "Result");
      formData.append("section",navigationOn);
      formData.append("tierID", tierId);
      AsyncCallHandler(
        NEXUS_CONST.PUT_CONFIRMRESULT_ATTACHMENT,
        NEXUS_CONST.PUT,
        formData
      ).then((res) => {
        setEanbleSave(false);
        dispatch({
          type: ACTION_TYPES.PUT_CONFIRMRESULT_ATTACHMENT,
          payload: res.data,
        });
        action.resultsGetAttachmentsData(dispatch, theRpsId, "Result");
        setSelectedFiles([]);
        setisOpen("8");
        //fetchRPSRail(dispatch, rpsID)
      });

      // action.putConfirmResultsFileData(dispatch, formData);
    }

    handleSPSSave();
    setisOpen("8");
  };

  const radioSelectTimePeriod = (event) => {
    const newTimePeriod = event.target.value;

    if (gridData.length > 0) {
      confirm(
        "Changing the time period will reset the data. Are you sure you want to proceed?"
      ).then((res) => {
        if (res) {
          setSelectedTimePeriod(newTimePeriod);
          gridDataPopulation("", newTimePeriod, "");

          return;
        } else {
          let prev = selectedTimePeriod;

          setSelectedTimePeriod(prev);
          return false;
        }
      });
    }

    setSelectedTimePeriod(newTimePeriod);
  };
  const radioSelectRptingFrequency = (event) => {
    const newRptingFrequency = event.target.value;

    if (gridData.length > 0) {
      confirm(
        "Changing the reporting frequency will reset the data. Are you sure you want to proceed?"
      ).then((res) => {
        if (res) {
          setSelectedFrequency(newRptingFrequency);
          gridDataPopulation(newRptingFrequency, "", "");

          return;
        } else {
          let prev = selectedFrequency;

          setSelectedFrequency(prev);
          return false;
        }
      });
    }

    setSelectedFrequency(newRptingFrequency);
  };
  const onFileSelect = (e) => {
    setSelectedFiles(e.value);
    if (e.value[0] !== undefined) {
      setImage(URL.createObjectURL(e.value[0]));
    }
  };
  const handleKPIDataChange = (e) => {
    setKpiInfo(e.value);
  };
  const enableDisableCntrols = () => {
    return rcaConfirmResultData?.length > 0;
  };

  const deleteFile = (id) => {
    let confirm_it = confirm(
      "Are you sure you want to delete?",
      "Confirm changes"
    );
    confirm_it.then((res) => {
      if (res) {
        action.deleteResultsFileAttachment(dispatch, id, tierId,siteId,navigationOn,theRpsId);
      } else {
        return false;
      }
    });
  };

  return (
    <div>
      <div className="title-section">
        {" "}
        <h2 className="sps_title">
          <span className="sps-print">Box 8 - &nbsp;</span>Confirmed Results
        </h2>{" "}
        <div className="sps-save-btn save-btn">
          <Button
            style={{ float: "right", width: "140px", "margin-top": "3%" }}
            disabled={enableSave}
            width={200}
            onClick={onSaving}
            text="Save"
            type="normal"
          />
        </div>
      </div>
      <ScrollView width="100%" className="sps-box-s" style={{ height: 420 }}>
        <div className="main_c">
          <div className="container"></div>
          <div className="dx-field cr-box-8">
            <div className="datagrid-machine_confirm">
              <div className="kp_op_container">
                <div className="kpi">
                  <TextBox
                    name="KPI"
                    label="KPI (*)"
                    value={
                      rpsAllData !== undefined && rpsAllData?.kpiunits !== null
                        ? rpsAllData?.kpiunits
                        : kpiInfo
                    }
                    disabled={enableDisableCntrols()}
                    onValueChanged={handleKPIDataChange}
                    className="dx-field-value "
                  ></TextBox>
                  <span className="date_input">
                    <DateBox
                      label="Start Date (*)"
                      placeholder="MM/DD/YYYY"
                      defaultValue={selectedDate}
                      value={selectedDate}
                      onValueChanged={handleDateChange}
                      disabled={enableDisableCntrols()}
                      type="date"
                      min={new Date().toISOString().split("T")[0]}
                    />
                  </span>
                </div>
              </div>
              <div className="timePeriod">
                {enableDisableCntrols() ? (
                  <span>{`Time Period (days)(*) :`}</span>
                ) : null}
                {!enableDisableCntrols() ? (
                  <div>
                    <span>{`Time Period (days)(*) :`}</span>
                    <input
                      className="radio-button-selection"
                      style={{ marginLeft: "33px" }}
                      type="radio"
                      value="30"
                      name="timePeriod"
                      checked={selectedTimePeriod == "30"}
                      disabled={enableDisableCntrols()}
                      onChange={radioSelectTimePeriod}
                      defaultChecked
                    />{" "}
                    30
                    <input
                      className="radio-button-selection"
                      type="radio"
                      value="60"
                      name="timePeriod"
                      checked={selectedTimePeriod == "60"}
                      disabled={enableDisableCntrols()}
                      onChange={radioSelectTimePeriod}
                    />{" "}
                    60
                    <input
                      className="radio-button-selection"
                      type="radio"
                      value="90"
                      name="timePeriod"
                      checked={selectedTimePeriod == "90"}
                      disabled={enableDisableCntrols()}
                      onChange={radioSelectTimePeriod}
                    />{" "}
                    90
                  </div>
                ) : (
                  <span>{" " + rpsAllData?.resultTimePeriod}</span>
                )}
              </div>
              <div className="reportingFrequency">
                {enableDisableCntrols() ? (
                  <span>{`Reporting Frequency (*) :`}</span>
                ) : null}
                {!enableDisableCntrols() ? (
                  <div>
                    <span>{`Reporting Frequency (*) :`}</span>
                    <input
                      className="radio-button-selection"
                      style={{ marginLeft: "16px" }}
                      type="radio"
                      value="Daily"
                      name="rptingFrequency"
                      checked={selectedFrequency == "Daily"}
                      onChange={radioSelectRptingFrequency}
                      disabled={enableDisableCntrols()}
                      defaultChecked
                    />{" "}
                    Daily
                    <input
                      className="radio-button-selection"
                      type="radio"
                      value="weekly"
                      checked={selectedFrequency == "weekly"}
                      onChange={radioSelectRptingFrequency}
                      disabled={enableDisableCntrols()}
                      name="rptingFrequency"
                    />{" "}
                    Weekly
                  </div>
                ) : (
                  <span>{" " + rpsAllData?.resultFrequency}</span>
                )}
              </div>
              <div className="startDate"></div>
              <DataGrid
                style={{
                  padding: "10px",
                  backgroud: "black",

                  height: "290px",
                }}
                ref={dataGridRef}
                id="gridContainerConfirm"
                dataSource={
                  rcaConfirmResultData?.length > 0
                    ? rcaConfirmResultData
                    : gridData
                }
                rowAlternationEnabled={true}
                showBorders={true}
                onInitNewRow={onInitNewRow}
              >
                <Scrolling mode="virtual" showScrollbar="always" />
                <Paging enabled={false} />
                <Editing mode="cell" allowUpdating={true} />

                <Column
                  dataField="resultDate"
                  caption="Date"
                  allowEditing={false}
                  minWidth={20}
                ></Column>
                <Column
                  dataField="target"
                  caption="Target (%)"
                  dataType="number"
                  allowEditing={!enableDisableCntrols()}
                  minWidth={20}
                ></Column>
                <Column
                  dataField="actual"
                  caption="Actual (%)"
                  dataType="number"
                  allowEditing={enableDisableCntrols()}
                  minWidth={20}
                ></Column>
                <Column
                  dataField="notes"
                  caption="Notes"
                  allowEditing={enableDisableCntrols()}
                  minWidth={20}
                ></Column>
              </DataGrid>
              <div
                className="dx-field no-print"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <div className="dx-field-label">Attachment</div>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                  }}
                >
                  <FileUploader
                    className="dx-field-value gridavailable"
                    selectButtonText="Choose file"
                    labelText="Max. File Size 4 MB"
                    accept="*"
                    uploadMode="uploadUrl"
                    multiple={true}
                    onValueChanged={onFileSelect}
                    value={selectedFiles}
                    allowedFileExtensions={ALLOWED_FILE_EXTENSIONS}
                  />

                  <div>
                    {resultsAttachmentData &&
                      resultsAttachmentData.map((item) => (
                        <div>
                          <a
                            style={{ cursor: "pointer" }}
                            className="clickable-hover"
                            onClick={() => {
                              getTypeOfFile(
                                {
                                  imageName: item?.attachmentName,
                                  folderName: "RPS",
                                  subfolderName: "Result",
                                  fileExtension: "xls",
                                },
                                "RPS"
                              );
                            }}
                          >
                            {" "}
                            {item?.attachmentName}{" "}
                          </a>
                          <span className="rca_download">
                            <i
                              title="Download"
                              className="fa fa-download pointer"
                              onClick={() =>
                                onDownloadFile(
                                  item?.attachmentName,
                                  "RPS",
                                  "Result"
                                )
                              }
                            ></i>
                          </span>
                          <span
                            className="rca_delete"
                            style={{ padding: "0px 15px 0px 10px" }}
                          >
                            <i
                              title="Delete"
                              className="fas fa-trash pointer"
                              onClick={() => deleteFile(item.id)}
                            ></i>
                          </span>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="thelinechart">
              {rcaConfirmResultData && rcaConfirmResultData.length > 0 ? (
                <LineChart
                  target={targetTitle}
                  actual={actualTitle}
                  chartId={chartId}
                  chartData={
                    rcaConfirmResultData !== undefined
                      ? rcaConfirmResultData
                      : []
                  }
                />
              ) : null}
            </div>
          </div>
        </div>
      </ScrollView>
    </div>
  );
};

export default ConfirmedResultsRPS;
